import {BrowserRouter} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {UserContext} from "./utils/shared/Context"
import {ToastNotificationsBlock} from './toast/toast-notifications-block'
import {initMeta} from './utils/pageMetaTag'
import AppRouter from './components/AppRouter'
import UserStore from './store/UserState'
import setDeviceViewSize from './utils/setDeviceViewSize'
import {captureGiftVoucher} from './utils/giftVoucher'

//Capture a ?voucher= code from the landing URL at module load — before any component (and the order
//store's localStorage-reading initializer) renders, so a direct /order?voucher= visit still sees it.
captureGiftVoucher()

const App = () => {
    const { t } = useTranslation()
    setDeviceViewSize()
    initMeta({
        serviceTitle: 'LoveInBook',
        description: t('desc main', { ns: 'main' })
    })

    return <UserContext.Provider value={{
        user: new UserStore()
    }}>
        <BrowserRouter>
            <AppRouter/>
        </BrowserRouter>
        <ToastNotificationsBlock/>
    </UserContext.Provider>
}

export default App